






































































































































































import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { TyTypeParameterState } from '@/common/interface/ty_type';
import { DEGREE_MAP } from '@/common/constants/ty_type';
import { DegreeInterface } from '@/common/interface/ty_type';

import { QuillEditor, IntroItem } from '@/common/interface';
import { isMobile } from '@/common/utils/getPlaform';
import { getInputStyle } from '@/common/utils/getStyles';
import { replaceString } from '@/common/utils/dealWithString';
import getUrlParam from '@/common/utils/getUrlParam';
import { resolveBoundaryValue } from '@/common/utils/format';

import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import DashLine from '@/components/common/edit/DashLine.vue';
import ImageUpload from '@/components/common/edit/ImageUpload.vue';
import FieldButton from '@/components/common/edit/FieldButton.vue';
import { MAX_NUM } from '@/common/constants';
import { majorNoticeText } from '@/common/constants/index';
import fetch from '@/common/api/fetch';
import PrizeIntroList from './PrizeIntroList.vue';

const INTERVAL_MIN = 0.1;
const INTERVAL_MAX = 999.9;

interface Payload {
  item: IntroItem;
}
const addText = require('@/assets/img/add-text.png');
const addImg = require('@/assets/img/add-img.png');
const addVedio = require('@/assets/img/add-vedio.png');
@Component({
  components: {
    'activity-label': ActivityLabel,
    'dash-line': DashLine,
    'image-upload': ImageUpload,
    'field-button': FieldButton,
    'prize-intro-list': PrizeIntroList
  }
})
export default class PrizeDescribe extends Vue {
  @Getter('section') section!: any;
  @Getter('tyTypeParameter') tyTypeParameter!: TyTypeParameterState;
  @Getter('chance') chance!: number; // 概率
  @Getter('count') count!: number; // 次数
  @Getter('chooseDegree') chooseDegree!: any;
  @Getter('titleSection') titleSection!: any;
  @Getter('sectionPrizeIntrosTextNum') sectionPrizeIntrosTextNum!: number;
  @Getter('sectionPrizeIntrosImgNum') sectionPrizeIntrosImgNum!: number;
  @Getter('xcxType') xcxType!: string;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('orgId') orgId!: string;
 
  @Action('changeSectionInfo') changeSectionInfo!: Function;
  @Action('changeChooseDegree') changeChooseDegree!: Function;
  @Action('changeChanceCount') changeChanceCount!: Function;
  @Action('changeTyTypeParameter') changeTyTypeParameter!: Function;
  @Action('addSectionPrizeIntros') addSectionPrizeIntros!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;
  

  isMobile: Function = isMobile;
  getUrlParam: Function = getUrlParam;
  replaceString: Function = replaceString;
  degreeMap: DegreeInterface = DEGREE_MAP;
  showVideo: Boolean = false;
  selectItem: any = {};
  videoList: any = [];
  addText: string = addText;
  addImg: string = addImg;
  addVedio: string = addVedio;
  get inputStyle() {
    const { inputFontColor, inputBackgroundColor } = this.section;
    return getInputStyle(inputFontColor, inputBackgroundColor);
  }

  get prizeImageList(): Array<string> {
    let prizePic = this.section.prizePic;
    return (prizePic || '').split('@').filter((value: string) => {
      if (value) {
        return value;
      }
    });
  }

  handleChangeInput(value: number, type: string) {
    if (type === 'unitNum' || type === 'goodValue' || type === 'normalValue' || type === 'badValue') {
      this.changeChooseDegree({
        name: '自定义',
        index: 3
      });
    }

    const payload: any = {};
    payload[type] = value;
    if (type === 'prizeNum') {
      payload['prizeLeftCount'] = value;
    }
    this.changeTyTypeParameter(payload);
    if (type !== 'prizeNum') {
      this.calculateChance();
    }
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    const _value = resolveBoundaryValue(value, hasDecimal);
    if (type !== 'intervalTime') {
      this.changeTyTypeParameter({ [type]: _value }).then(() => {
        if (type !== 'prizeNum') {
          this.calculateChance();
        }
      });
    }

    if (type === 'intervalTime') {
      if (value < INTERVAL_MIN) {
        this.changeTyTypeParameter({ [type]: INTERVAL_MIN });
      } else if (value > INTERVAL_MAX) {
        this.changeTyTypeParameter({ [type]: INTERVAL_MAX });
      } else if (value <= INTERVAL_MIN && INTERVAL_MAX >= value) {
        this.changeTyTypeParameter({ [type]: Number(value).toFixed(1) });
      }
    }
  }

  // 计算完成度
  calculateChance() {
    let count = 0;
    let chance = 0;
    const { unitNum, goodValue, normalValue, badValue } = this.tyTypeParameter;
    count = unitNum / (goodValue * 0.25 + normalValue * 0.65 + badValue * 0.1);

    if (count <= 1) {
      chance = 1;
    } else if (count > 1 && count < 35) {
      chance = -0.018 * count + 0.664;
    } else {
      chance = 1 / (1.72 * count + 25);
    }

    const payload = {
      chance: Math.round(chance * 100),
      count: Math.round(count)
    };
    this.changeChanceCount(payload);
  }

  onEditorChange(quill: QuillEditor) {
    this.changeSectionInfo({
      value: quill.html,
      type: 'prizeDesc'
    });
  }

  // 修改奖品图片
  handleChangePrizeImage(imgUrl: string) {
    let prizePic: string = this.section.prizePic;
    prizePic = prizePic + '@' + imgUrl;
    const payload = {
      value: prizePic,
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  // 删除奖品图片
  handleDeletePrizeImage(index: number) {
    const prizeImageList = Array.from(this.prizeImageList);
    prizeImageList.splice(index, 1);
    const payload = {
      value: prizeImageList.join('@'),
      type: 'prizePic'
    };
    this.changeSectionInfo(payload);
  }

  // 切换活动难度
  handleChangeDegree(item: any): void {
    if (getUrlParam('type') === 'reEdit') {
      return;
    }
    if (item !== this.chooseDegree) {
      this.changeChooseDegree(item);
    }
    if (item.index !== 3) {
      const payload = {
        chance: item.chance,
        count: item.count
      };
      this.changeChanceCount(payload);
      const helpCount = {
        goodValue: item.goodValue,
        normalValue: item.normalValue,
        badValue: item.badValue,
        unitNum: item.unitNum
      };
      this.changeTyTypeParameter(helpCount);
    }
  }

  handleAddTextIntro(): void {
    if (this.sectionPrizeIntrosTextNum < 10) {
      const introItem: IntroItem = {
        type: 'text',
        value: ''
      };
      const payload: Payload = {
        item: introItem
      };
      this.addSectionPrizeIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个文本');
    }
  }
  handleAddImage(imgUrl: string): void {
    if (this.sectionPrizeIntrosImgNum < 10) {
      const filedImgs = document.getElementsByClassName('field-img-upload');
      Array.from(filedImgs).forEach((img: any) => {
        img.value = '';
      });
      const introItem: IntroItem = {
        type: 'img',
        value: imgUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.addSectionPrizeIntros(payload);
    } else {
      Vue.$toast.info('最多添加10个图片');
    }
  }
  handleShowVideo(): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定'
      });
      return;
    }
    this.getVideoList();
    this.showVideo = true;
    this.changeShowFooter(false);
  }
  selectVideo(): void {
    if (this.selectItem.videoUrl) {
      const introItem: IntroItem = {
        type: 'video',
        value: this.selectItem.videoUrl,
        coverUrl: this.selectItem.coverUrl
      };
      const payload: Payload = {
        item: introItem
      };
      this.showVideo = false;
      this.addSectionPrizeIntros(payload);
      this.changeShowFooter(true);
    }
  }
  handleCloseVideo(): void {
    this.selectItem = {};
    this.showVideo = false;
    this.changeShowFooter(true);
  }
  getVideoList() {
    const instId = getUrlParam('instId');
    const activityId = getUrlParam('broadcastId');
    if (instId) {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { instId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    } else {
      return fetch.Sales('anon/businessShow/getCustomizeVideoList', { activityId }).then((res: any) => {
        this.videoList = res.result || [];
        this.videoList.map((item: any) => {
          item.bag = item.coverUrl || item.videoUrl + '?x-oss-process=video/snapshot,t_1,m_fast';
        });
        (this.section.prizeIntros || []).map((item: any) => {
          if (item.type == 'video') {
            this.selectItem = {
              videoUrl: item.value,
              coverUrl: item.coverUrl
            };
          }
        });
      });
    }
  }
}
